// thunk.js

import { toast } from "react-toastify";

import {
  fetchStockoutRequestSOStart,
  fetchStockoutRequestSOSuccess,
  fetchStockoutRequestSOFailure,
} from "./reducer";

import { STOCK_OUT_REQUEST_SO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const stockoutRequestSO =
  (id, jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchStockoutRequestSOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        STOCK_OUT_REQUEST_SO(id),
        "POST",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchStockoutRequestSOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchStockoutRequestSOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success(response.Message);
        onSuccess && onSuccess(response);
      }
    } catch (error) {
      dispatch(fetchStockoutRequestSOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
